// extracted by mini-css-extract-plugin
export default {"ModalSetPublicKey":"ModalSetPublicKey_ModalSetPublicKey__u3uTD","ModalSetPublicKey__footer":"ModalSetPublicKey_ModalSetPublicKey__footer__07C-s"};